import { CdkPortalOutlet } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  ViewChild,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { FloatingPanelService } from '../../../../../shared/misc-services/floating-panel.service';

@Component({
  selector: 'h3-floating-feedback-panel',
  styleUrls: ['./floating-feedback-panel.component.scss'],
  templateUrl: './floating-feedback-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FloatingFeedbackPanelComponent extends DirectiveSuperclass {
  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet!: CdkPortalOutlet;
  floatingPanelService = inject(FloatingPanelService);
  portal$ = this.floatingPanelService.portal$;

  constructor(injector: Injector) {
    super(injector);
    this.subscribeTo(this.floatingPanelService.close$, () => {
      this.portalOutlet.detach();
    });
  }
}
